export default [
  {
    key: 'defaultValue',
    ignore: true,
  },
];
